/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Icon } from 'components/common';
import {
  sectionStyles,
  sectionTitleStyles,
  sectionBodyStyles,
  fieldStyles,
  fieldLabelStyles,
  actionsStyles,
  applyButtonStyles,
  resetButtonStyles,
} from './Sidebar.styles';

const isActive = (value) => {
  if (value === null || value === undefined || value === '') return false;
  if (Array.isArray(value)) return value.some(isActive);
  if (value instanceof Date) return true;
  if (typeof value === 'object') {
    return 'value' in value ? isActive(value.value) : Object.values(value).some(isActive);
  }
  return true;
};

// Counts filled filters in a filterCondition object (search excluded) plus any extra
// values kept outside it, such as date ranges held in separate state.
export const countActiveFilters = (filterCondition = {}, ...extra) => (
  Object.entries(filterCondition).filter(([key, value]) => key !== 'search' && isActive(value)).length
  + extra.filter(isActive).length
);

export const FilterSection = ({ title, children }) => {
  const [isOpen, setOpen] = useState(true);

  return (
    <section css={sectionStyles}>
      <button
        type="button"
        css={sectionTitleStyles}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} />
      </button>
      {isOpen && <div css={sectionBodyStyles}>{children}</div>}
    </section>
  );
};

FilterSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const FilterField = ({ label, children }) => (
  <div css={fieldStyles}>
    <span css={fieldLabelStyles}>{label}</span>
    {children}
  </div>
);

FilterField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const FilterActions = ({ onApply, onReset, applyType }) => (
  <div css={actionsStyles}>
    <Button type="button" onClick={onReset} styles={resetButtonStyles}>reset</Button>
    <Button type={applyType} onClick={onApply} styles={applyButtonStyles}>apply</Button>
  </div>
);

FilterActions.propTypes = {
  onApply: PropTypes.func,
  onReset: PropTypes.func.isRequired,
  applyType: PropTypes.oneOf(['button', 'submit']),
};

FilterActions.defaultProps = {
  onApply: undefined,
  applyType: 'button',
};
